import React from 'react';

export function SliderArrowNext(props) {
    const { onClick } = props
  
    return (
      <div className="slider-arrow next cursor-pointer" onClick={onClick}>
        <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.13 50">
          <polygon className="cls-1" points="18.13 24.22 2.52 0 0 1.63 14.6 24.27 0.01 48.45 2.57 50 18.13 24.22"/>
        </svg>
      </div>
    )
  }
  
  
export function SliderArrowPrev(props) {
  const {onClick} = props

  return (
    <div className="slider-arrow prev cursor-pointer" onClick={onClick}>
      <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.13 50">
        <polygon className="cls-1" points="0 25.78 15.61 50 18.13 48.38 3.54 25.73 18.13 1.55 15.56 0 0 25.78"/>
      </svg>
    </div>
  )
}
